import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BooleanDataTypeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BooleanDataType",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.98 14.05c-.32 0-.62-.12-.86-.35L2.35 9.93C2.12 9.7 2 9.4 2 9.07s.12-.62.35-.86c.23-.23.54-.35.86-.35s.63.12.86.35l2.87 2.92 6.66-6.66c.25-.29.59-.45.95-.45.67 0 1.22.55 1.22 1.22 0 .36-.16.7-.44.94l-7.5 7.53c-.23.23-.53.35-.86.35Zm.55 8.44c-.3 0-.59-.11-.8-.33s-.33-.5-.33-.8.11-.59.33-.8L23.22 4.09c.22-.22.5-.33.8-.33s.59.11.8.33c.44.44.44 1.16 0 1.61L8.33 22.17c-.22.22-.5.33-.8.33Zm18.24-.16 3.88-3.89c.46-.46.46-1.21 0-1.68-.46-.46-1.21-.46-1.68 0l-3.88 3.89-3.89-3.89c-.46-.46-1.21-.46-1.68 0s-.46 1.21 0 1.68l3.89 3.89-3.89 3.88c-.46.46-.46 1.21 0 1.68.23.24.53.35.83.35s.61-.11.84-.35l3.89-3.88 3.88 3.88c.24.24.54.35.84.35s.61-.11.83-.35c.46-.46.46-1.21 0-1.68l-3.88-3.88Z"
    })
  }));
};